import React  from 'react';
import {HtmlParse} from 'utils';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

const RecipeIngredients = (props) => {

    const recipeIngredients = props.item ? props.item : '';
    const description = props && props.item ? props.item.description : '';


    return (
        <div className="recipes-ingredients">
            <div className="recipes-ingredients-title">
                <span>{recipeIngredients.title}</span>
            </div>
            <div className="recipes-ingredients-description">
                <span>{HtmlParse(description ? description : '')}</span>
            </div>
        </div>
    )
}

RecipeIngredients.propTypes = {
    item: PropTypes.object
};

export default RecipeIngredients;
